import { StyleSheet, View } from 'react-native';
import { Text, theme, styles as baseStyles } from '@socrait/react';

import { firstRunPng2, firstRunPng3, firstRunPng4 } from './assets';

export const TutorialSlide = () => {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>How Socrait Works</Text>
      <View style={styles.tutorialContainer}>
        <View style={styles.tutorialItem}>
          <Text style={[baseStyles.boldText, styles.text]}>1. Press the Stream button</Text>
          <img src={firstRunPng2} style={styles.image} />
        </View>
        <View style={styles.tutorialItem}>
          <Text style={[baseStyles.boldText, styles.text]}>2. Teach as you normally do!</Text>
          <img src={firstRunPng3} style={styles.image} />
          <Text style={styles.text}>Stop the mobile app at the end of class.</Text>
        </View>
        <View style={styles.tutorialItem}>
          <Text style={[baseStyles.boldText, styles.text]}>3. See your data!</Text>
          <img src={firstRunPng4} style={styles.image} />
          <Text style={styles.text}>
            Log into <Text style={[baseStyles.boldText, styles.text]}>socrait.com</Text> on your computer to see all
            your data!
          </Text>
        </View>
      </View>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: 'column',
    justifyContent: 'center',
    gap: theme.spacing.xxlarge,
  },
  title: {
    fontSize: theme.fontSizes.xlarge,
    textAlign: 'center',
  },
  tutorialContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center',
    gap: theme.spacing.xlarge,
  },
  tutorialItem: {
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing.xlarge,
    minWidth: 200,
    maxWidth: 350,
    flex: 1,
  },
  image: {
    height: 'clamp(100px, 20vw, 300px)',
    width: '100%',
    objectFit: 'contain',
  },
  text: {
    fontSize: theme.fontSizes.xmedium,
    lineHeight: 33.6, //TODO: add this to socrait-react
    justifyContent: 'center',
    textAlign: 'center',
  },
  purpleText: {
    color: theme.colors.primaryPurple,
  },
});
